<template>
  <div v-if="!isPageLoading" class="all-courses">
    <div
      v-if="selectedCourses && selectedCourses.length"
      class="all-courses__background"
      :style="
        `background-image: url(${$getCourseBackground(
          selectedCourses[0],
          'large'
        )}), linear-gradient(#151515, #262626);`
      "
    >
      <div class="all-courses__overlay"></div>
    </div>
    <section
      class="all-courses__wrapper"
      v-if="selectedCourses && selectedCourses.length"
    >
      <h4 class="all-courses__header">{{ selectionType }} Courses</h4>
      <div class="all-courses__courses-wrapper">
        <course-tile
          v-for="course in selectedCourses"
          :key="course.id"
          :course="course"
          :backgroundImg="$getCourseBackground(course, 'small')"
          :gradient="$getGradient()"
          :duration="$duration.getCourseDuration(course)"
          :customClass="'result-course'"
        ></course-tile>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CourseTile from '../components/layout/CourseTile.vue'

export default {
  name: 'AllCourses',
  components: {
    CourseTile,
  },
  data() {
    return {
      selectedCourses: [],
    }
  },
  computed: {
    ...mapGetters({
      isPageLoading: 'app/isPageLoading',
      popularCourses: 'courses/popular',
      trendingCourses: 'courses/trending',
      allNewCourses: 'courses/newCourses',
    }),
    selectionType() {
      const { name } = this.$route.params
      return name.charAt(0).toUpperCase() + name.slice(1)
    },
  },
  async created() {
    this.$store.dispatch('app/setIsPageLoading', true)
    switch (this.$route.params.name) {
      case 'popular':
        await this.$store.dispatch('courses/getPopularCourses', 20)
        this.selectedCourses = this.popularCourses
        break
      case 'trending':
        await this.$store.dispatch('courses/getTrendingCourses', 20)
        this.selectedCourses = this.trendingCourses
        break
      case 'new':
        await this.$store.dispatch('courses/getNewCourses', 20)
        this.selectedCourses = this.allNewCourses
        break
      default:
        this.$router.push({ name: 'home' })
    }
    this.$store.dispatch('app/setIsPageLoading', false)
  },
}
</script>

<style lang="scss" scoped>
.all-courses {
  position: relative;
  &__background {
    min-height: 100vh;
    width: 100%;
    position: absolute;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 0;
  }
  &__overlay {
    position: relative;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0.7),
      var(--dark-gray),
      var(--dark-gray)
    );
    z-index: 0;
    min-height: 100vh;
    width: 100%;
  }
  &__header {
    color: var(--white);
  }
  &__wrapper {
    position: relative;
    padding: 150px 25px;
    @include tablet {
      padding: 150px 75px;
    }
  }
  &__courses-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 0 auto;
    width: 100%;
  }
  .result-course {
    width: 100%;
    padding: 5px;
    @include tablet {
      width: 50%;
    }
    @include desktop {
      width: 25%;
    }
    @include lg-desktop {
      width: 15%;
    }
  }
}
</style>
